<template>
  <v-app id="calendrier_activite" toolbar footer>
    <v-navigation-drawer
            persistent
            v-model="drawerRight"
            light
            right
            enable-resize-watcher
            overflow
            v-if="proposeRight"
            class="pink darken-2"
    >
      <router-view name="droite"></router-view>
    </v-navigation-drawer>
    <router-view name="toolbar"></router-view>
    <main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </main>
    <v-footer class="pink darken-2">
      <span class="white--text">© Le Sénat 2019</span>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        drawerRight: true,
        right: null
      };
    },
    computed: {
      proposeRight() {
        return ("Accueil" !== this.$route.name);
      }
    }
  };
</script>

<style lang="stylus">
  @import './stylus/main';
</style>



// WEBPACK FOOTER //
// App.vue?6bf8f258